import Immutable, { Map } from 'immutable';
// import select from 'selectn';
import { AuthActions } from '../actions/auth';
import { AccountActions } from '../actions/account';
import { createStore, getActionIds } from '../helpers/redux';
import { currentAccountIdSelector } from './accounts';
import { currentProjectIdSelector } from './projects';
import { currentOrganizationIdSelector } from './organizations';
import { currentUserIdSelector } from './auth';
import { OrganizationActions } from '../actions/organization';
import { ProjectActions } from '../actions/project';
import { UserActions } from '../actions/user';
// import { ViewActions } from '../actions/view';

const authActions = getActionIds(AuthActions);
const userActions = getActionIds(UserActions);
// const viewActions = getActionIds(ViewActions);
const projectActions = getActionIds(ProjectActions);
const organizationActions = getActionIds(OrganizationActions);
const accountActions = getActionIds(AccountActions);

const initialState = Immutable.fromJS({
  users: {},
});

export const users = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return state.set('users', state.get('users', Map()).filter(a => {
      return a.get('id') === action.userId;
    }));
  },

  '*': (state, action) => {
    if (action.result && action.result.entities && action.result.entities.users) {
      return state.mergeDeep({
        users: action.result.entities.users,
      });
    }
    return state;
  },

  [authActions.getMeProjects.success]: (state, action) => {
    const projectUsers = action.result.entities.users;
    const projects = action.result.entities.projects;
    const me = projects && projects.length > 0 ? projects[Object.keys(projects)[0]].me : null; // there is no user id on this get request
    if (!me) return state;

    const myUserObject = Object.keys(projectUsers)
      .filter(key => (key === me))
      .reduce((obj, key) => {
        const userObj = projectUsers[key];
        obj[key] = userObj;
        return obj;
      }, {});

    return state.mergeDeep({
      users: myUserObject,
    });
  },

  [projectActions.createProject.success]: (state, action) =>
    state.mergeDeep({
      users: action.result.entities.users,
    }),

  [projectActions.copyProject.success]: (state, action) => {
    const projectId = action.result.result;
    const userId = action.args[1];
    return state.setIn(['users', userId, 'roles', 'project', projectId], 1);
  },

  [projectActions.deleteProject.success]: (state, action) => {
    const projectId = action.args[0];
    const userId = action.args[2];

    return state.deleteIn(['users', userId, 'roles', 'project', projectId]);
  },

  [userActions.getProjectUsers.success]: (state, action) =>
    state.mergeDeep({
      users: action.result.entities.users,
    }),

  [userActions.addProjectUser.success]: (state, action) => {
    const x = (action.result.entities.users) ? state.mergeDeep({
      users: action.result.entities.users,
    }) : state;
    // console.log('x', x, state, action);
    return x;
  },

  [projectActions.removeProjectUser.success]: (state, action) =>
    state.deleteIn(['users', action.result.userId]),

  [organizationActions.getOrganizationUsers.success]: (state, action) =>
    state.mergeDeep({
      users: action.result.entities.users,
    }),

  [accountActions.getAccountUsers.success]: (state, action) =>
    state.mergeDeep({
      users: action.result.entities.users,
    }),

  [userActions.updateProfile.success]: (state, action) =>
    state.mergeDeep({
      users: action.result.entities.users,
    }),

  [userActions.confirmEmail.success]: (state, action) =>
    state.mergeDeep({
      users: action.result.entities.users,
    }),

  [userActions.updateAvatar.success]: (state, action) =>
    state.mergeDeep({
      users: action.result.entities.users,
    }),

  [userActions.deleteAvatar.success]: (state, action) =>
    state.deleteIn(['users', action.args[0], 'avatar'])
      .setIn(['users', action.args[0], 'has_avatar'], false)
      .setIn(['users', action.args[0], 'avatar_id'], null),

  [organizationActions.deleteOrganization.success]: (state, action) =>
    state.deleteIn(['users', action.args[1], 'roles', 'organization', action.args[0]]),

  [accountActions.deleteAccount.success]: (state, action) =>
    state.deleteIn(['users', action.args[1], 'roles', 'account', action.args[0]]),

  [accountActions.createAccount.success]: (state, action) =>{
    const accountId = Object.keys(action.result.entities.accounts)[0];
    return state.mergeDeep({
      users: {
        [action.args[1]]: {
          roles: {
            account: {
              [accountId]: 1,
            },
          },
        },
      },
    });
  },

  [organizationActions.createOrganization.success]: (state, action) => {
    const organizationId = Object.keys(action.result.entities.organizations)[0];
    return state.mergeDeep({
      users: {
        [action.args[1]]: {
          roles: {
            organization: {
              [organizationId]: 1,
            },
          },
        },
      },
    });
  },

});

export const projectRoleSelector = (state) => {
  const currentUser = currentUserSelector(state);
  const currentProjectId = currentProjectIdSelector(state);
  return currentUser.getIn(['roles', 'project', currentProjectId]);
};

export const accountRoleSelector = (state) => {
  const currentUser = currentUserSelector(state);
  const currentAccountId = currentAccountIdSelector(state);
  return currentUser.getIn(['roles', 'account', currentAccountId]);
};

export const organizationRoleSelector = (state) => {
  const currentUser = currentUserSelector(state);
  const currentOrganizationId = currentOrganizationIdSelector(state);
  return currentUser.getIn(['roles', 'organization', currentOrganizationId]);
};

export const userRolesSelector = (state) => {
  const currentUser = currentUserSelector(state);
  return currentUser.get('roles', Map());
};

export const currentUserSelector = (state) => {
  const currentUserId = currentUserIdSelector(state);
  return state.users.getIn(['users', currentUserId], Map());
};

export const userModeSelector = (state) => state.project.get('userMode', 'reader');

export const usersSelector = (state) => state.users.get('users');

export const getUserModeByProjectId = (user, projectId) => {
  const userMap = {
    1: 'admin',
    2: 'admin',
    3: 'user', // author
    4: 'reader',
  };
  const roleId = user.getIn(['roles', 'project', projectId], null);
  return userMap[roleId];
};



// WEBPACK FOOTER //
// ./src/reducers/users.js